<div class="main">
  <div class="info">
    <h2>Campos editables</h2>
    <p>Pueden incluirse campos en el documento a editar por los firmantes.</p>
  </div>

  <app-campos-editables-firmante *ngFor="let tipo of mostrarFirmantes" [firmante]="tipo" (firmanteSeleccionado)="seleccionarFirmante($event)"></app-campos-editables-firmante>
</div>

